<template>
  <v-footer dark padless>
    <v-card
      flat
      tile
      width="100%"
      class="grey darken-3 white--text text-center"
    >
      <v-card-text>
        <v-btn
          v-for="(item, index) in socials"
          :key="index"
          class="mx-4 white--text"
          icon
          @click="goLink(item.link)"
          :title="item.title"
        >
          <v-icon size="24px">{{ item.ico }}</v-icon>
        </v-btn>

        <v-btn class="mx-4 white--text" icon @click="showPlaylist()" title="PlayList">
          <v-icon size="24px">mdi-playlist-music</v-icon>
        </v-btn>

        <v-btn class="mx-4 white--text" icon @click="showContato()" title="Entre em contato">
          <v-icon size="24px">mdi-email-outline</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0"></v-card-text>
      <h3>Quem somos</h3>

      <p>
        <span style="font-family: 'Fontdiner Swanky', serif; font-size: 1.1rem;"
          >VIOLENT NOISE</span
        >
        é um espaço destinado aos apreciadores do Rock, Hardcore, Metal e todas
        as suas subdivisões e vertentes.
        <br />
        Trata-se de um ambiente virtual para conhecer, compartilhar e discutir o
        cenário Underground tanto musical como cultural.
      </p>
      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} —
        <strong>Violent Noise &reg;</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    socials: [
      {
        title: "Facebook",
        ico: "mdi-facebook",
        link: "https://www.facebook.com/violentnoiseblog/"
      },
      /*
      { 
        title: "",
        ico: 'mdi-twitter',
        link: ''
      },
      */
      {
        title: "Blog",
        ico: "mdi-blogger",
        link: "https://blog.violentnoise.com.br"
      },
      /*
      { 
        ico: 'mdi-linkedin',
        link: ''
      },
      */
      {
        title: "Instagram",
        ico: "mdi-instagram",
        link: "https://www.instagram.com/violentnoiseblog"
      },
      {
        title: "Spotify",
        ico: "mdi-spotify",
        link:
          "https://open.spotify.com/user/tco44mhstu8c0emses2spng10?si=z2YwNEM0QxaHaItu64Xa7A"
      }
    ]
  }),
  methods: {
    goLink: function(newLink) {
      window.open(newLink, "_blank");
    },
    showPlaylist: function() {
      this.$store.commit("setIsSpotify", true);
    },
    showContato: function() {
      this.$store.commit("setIsContato", true);
    }
  }
};
</script>
